document.addEventListener("shopify:section:load", initVideos);
document.addEventListener("DOMContentLoaded", initVideos);

function initVideos() {
  const deferredMedia = document.querySelectorAll("deferred-media");

  deferredMedia.forEach((media) => {
    const template = media.querySelector("template");

    if (template) {
      const content = template.content.cloneNode(true);
      media.appendChild(content);
      template.remove();
    }

    const video = media.querySelector("video");
    if (video) {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.play().catch(() => {});
    }

    const poster = media.querySelector(".deferred-media__poster");
    if (poster) poster.style.display = "none";
  });
}


document.addEventListener("DOMContentLoaded", function () {

  const input = document.querySelector('[id^="NewsletterPhone--"]');

  if (!input) return;

  window.intlTelInput(input, {
    initialCountry: "au",
    separateDialCode: true,
    preferredCountries: ["au", "in", "us", "gb"]
  });

});





document.querySelectorAll('.accordion__inner').forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
        const icon = this.querySelector('.accordion-icon');

        if (this.open) {
            icon.textContent = '−';
        } else {
            icon.textContent = '+';
        }
    });
});


window.addEventListener('load', function () {
  document.querySelectorAll('.main-product__media-badge').forEach(function (el) {
    if (el.textContent.trim().toLowerCase() === 'made to order') {
      el.classList.add('made-to-order');
    }
  });
});

/* MJ 2048-variant support (added Oct 2026).
   Mojave's product-selector only knows the first 250 variants of a product.
   When a chosen combination isn't among them, this looks it up through the
   Section Rendering API in ONE request (main product section + the
   sections/mj-variant-lookup.liquid helper) and shows a loading state,
   not "Unavailable", while it waits. */
customElements.whenDefined('product-selector').then(function () {
  var Selector = customElements.get('product-selector');
  if (!Selector || Selector.prototype.__mjVariantFix) return;
  Selector.prototype.__mjVariantFix = true;

  var proto = Selector.prototype;
  var originalUpdateMasterId = proto.updateMasterId;
  var originalToggleAddButton = proto.toggleAddButton;
  var originalSetUnavailable = proto.setUnavailable;

  function unavailableText() {
    return window.theme && window.theme.strings && window.theme.strings.product.unavailable;
  }

  proto.mjIsLarge = function () {
    try { return this.getVariantData().length >= 250; } catch (e) { return false; }
  };

  // Option value name -> ID map, fetched once per page (in the background on load).
  proto.mjLoadOptionIds = function () {
    var self = this;
    if (!this.mjOptionIdsPromise) {
      this.mjOptionIdsPromise = fetch(this.dataset.url + '?section_id=mj-variant-lookup')
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-mj-option-ids]');
          return el ? JSON.parse(el.textContent) : null;
        })
        .catch(function () { self.mjOptionIdsPromise = null; return null; });
    }
    return this.mjOptionIdsPromise;
  };

  proto.updateMasterId = function () {
    this.mjToken = (this.mjToken || 0) + 1;
    this.mjPending = false;
    originalUpdateMasterId.call(this);
    if (!this.currentVariant && this.mjIsLarge()) {
      this.mjPending = true;
      this.mjLookupVariant(this.mjToken);
    }
  };

  // While a lookup is running, show the loading spinner instead of "Unavailable".
  proto.toggleAddButton = function (disable, text) {
    if (this.mjPending && text === unavailableText()) {
      return originalToggleAddButton.call(this, true, '');
    }
    return originalToggleAddButton.call(this, disable, text);
  };

  proto.setUnavailable = function () {
    if (this.mjPending) return;
    return originalSetUnavailable.call(this);
  };

  proto.mjFail = function (token) {
    if (token !== this.mjToken) return;
    this.mjPending = false;
    originalToggleAddButton.call(this, true, unavailableText());
    originalSetUnavailable.call(this);
  };

  proto.mjLookupVariant = function (token) {
    var self = this;
    var options = (this.options || []).slice();
    var section = this.dataset.section;

    this.mjLoadOptionIds()
      .then(function (map) {
        if (!map) return null;
        var ids = [];
        for (var i = 0; i < map.length; i++) {
          if (map[i][options[i]] === undefined) return null;
          ids.push(map[i][options[i]]);
        }
        return fetch(
          self.dataset.url + '?option_values=' + ids.join(',') +
          '&sections=' + encodeURIComponent(section + ',mj-variant-lookup')
        ).then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        if (token !== self.mjToken) return;
        if (!sections || !sections['mj-variant-lookup']) return self.mjFail(token);

        var parser = new DOMParser();
        var lookup = parser.parseFromString(sections['mj-variant-lookup'], 'text/html');
        var el = lookup.querySelector('[data-mj-variant]');
        var variant = el ? JSON.parse(el.textContent) : null;
        if (!variant || !variant.options) return self.mjFail(token);
        for (var i = 0; i < variant.options.length; i++) {
          if (variant.options[i] !== options[i]) return self.mjFail(token);
        }

        self.mjPending = false;
        self.currentVariant = variant;
        var main = sections[section] ? parser.parseFromString(sections[section], 'text/html') : null;

        var steps = [
          function () { self.updatePickupAvailability(); },
          function () { self.updateMedia(); },
          function () { if (!self.closest('modal-dialog')) self.updateURL(); },
          function () { self.updateVariantInput(); },
          function () { self.updateSellingPlanId(''); },
          function () { self.updateSKU(); },
          function () {
            if (main) {
              // Same result as updateProductInfo(), without a second request.
              self.changeProductPrice(main);
              self.updateInventoryNotice(main);
              originalToggleAddButton.call(self, !variant.available, window.theme.strings.product.soldOut);
            } else {
              self.updateProductInfo();
            }
          }
        ];
        steps.forEach(function (step) { try { step(); } catch (e) {} });
      })
      .catch(function () { self.mjFail(token); });
  };

  // Warm the option ID map as soon as a large product page loads.
  document.querySelectorAll('product-selector').forEach(function (el) {
    if (el.mjIsLarge && el.mjIsLarge()) el.mjLoadOptionIds();
  });
});
